import createReducer from '../../utils/createReducer';
import actions from './actions';

const initialState = {
    modalOpen: false,
    tripboardButtonVisible: false
};

const actionHandlers = {};

actionHandlers[actions.CREATE_TRIPBOARD_OPEN_MODAL] = (state) => {
    const newState = {
        ...state,
        modalOpen: true
    };
    return newState;
};

actionHandlers[actions.CREATE_TRIPBOARD_CLOSE_MODAL] = (state) => {
    const newState = {
        ...state,
        modalOpen: false
    };
    return newState;
};

actionHandlers[actions.CREATE_TRIPBOARD_SHOW_BUTTON] = (state, {payload}) => {
    const newState = {
        ...state,
        tripboardButtonVisible: payload.tripboardButtonVisible
    };
    return newState;
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/tripboard/create-tripboard-controls/create-tripboard-reducer.js